import React, { useState } from "react";
import Layout from "../Layout";
import Banner from "../shared/Banner";
import Services from "../shared/Services";
import Portfolio from "../shared/Portfolio";
import CallToAction from "../shared/CallToAction";
import FreeQuotesModal from "../FreeQuotesModal";

const FeatureItem = ({ title, description }) => {
  return (
    <div>
      <div className="flex gap-4">
        <div className="w-[22px] h-[22px] min-w-[22px] rounded-full my-auto bg-primary flex justify-center items-center">
          <svg
            width="12"
            height="9"
            viewBox="0 0 12 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.62624 8.73031C4.5142 8.8391 4.36143 8.89985 4.20267 8.89985C4.04391 8.89985 3.89114 8.8391 3.77911 8.73031L0.396604 5.4626C0.0455329 5.12351 0.0455329 4.57378 0.396604 4.23526L0.820167 3.82615C1.17124 3.48705 1.73978 3.48705 2.09085 3.82615L4.20267 5.86593L9.90908 0.354175C10.2602 0.0150796 10.8293 0.0150796 11.1798 0.354175L11.6033 0.76329C11.9544 1.10239 11.9544 1.65211 11.6033 1.99063L4.62624 8.73031Z"
              fill="white"
            />
          </svg>
        </div>

        <h3 className="lg:text-[22px] sm:text-[20px] text-lg font-medium leading-7 text-gray-900 pb-px">
          {title}
        </h3>
      </div>
      <p className="mt-[10px] text-base leading-relaxed font-normal text-gray-700 max-md:max-w-full">
        {description}
      </p>
    </div>
  );
};

const PricingCard = ({ title, price, priceUnit, description, isPopular }) => (
  <div
    className={`bg-white rounded-2xl border border-gray-300 p-[30px] text-center ${
      isPopular ? "relative overflow-hidden" : ""
    }`}
  >
    {isPopular && (
      <div className="absolute top-[19px] -left-[31px] bg-primary text-white text-center text-sm leading-normal font-semibold uppercase py-1 px-8 -rotate-45">
        popular
      </div>
    )}
    <div className="border-b border-gray-300 pb-[30px] mb-[30px]">
      <h4 className="text-2xl font-medium text-gray-900 leading-tight mb-1.5 pb-px">{title}</h4>
      <p className="text-base font-normal text-gray-700 leading-normal">Starting from</p>
    </div>
    <div className="flex gap-1 items-center justify-center mb-[30px]">
      <h5 className="text-primary lg:text-4xl sm:text-3xl text-2xl font-bold !leading-tight">
        {price}
      </h5>
      <span className="lg:text-lg text-base font-medium text-gray-900">{priceUnit}</span>
    </div>
    <p className="text-base font-normal text-gray-700 leading-relaxed">{description}</p>
  </div>
);

const HireDeveloperDetails = ({
  title,
  description,
  developmentServices,
  whyHireInfyOm,
  hireDedicatedDevelopers,
  footerText,
  dropdownName,
}) => {
  const [showFreeQuotesModal, setShowFreeQuotesModal] = useState(false);

  return (
    <Layout>
      <Banner heading={title} subheading={description} isIndexPage="true" />
      <Services
        heading={developmentServices.title}
        services={developmentServices.services}
        desc={developmentServices.description}
        hireDeveloperPage={true}
      />
      <section className="lg:pt-[100px] sm:pt-16 pt-12 lg:pb-[100px] sm:pb-16 pb-12 lg:px-7 px-5">
        <div className="container max-w-7xl mx-auto">
          <h2 className="lg:text-[44px] lg:leading-[57px] leading-tight  sm:text-[40px] text-3xl font-semibold text-gray-900 max-w-[590px] ">
            {whyHireInfyOm.title}
          </h2>
          <div className="lg:mt-[60px] sm:mt-10 mt-7">
            <div className="grid lg:grid-cols-2 sm:gap-y-[45px] sm:gap-x-10 gap-8">
              {whyHireInfyOm.services.map((service, index) => (
                <FeatureItem key={index} title={service.title} description={service.description} />
              ))}
            </div>
          </div>
        </div>
      </section>
      <section className="lg:pt-[100px] sm:pt-16 pt-12 lg:pb-[100px] sm:pb-16 pb-12 lg:px-7 px-5 bg-gray-100">
        <div className="container max-w-7xl mx-auto">
          <h2 className="lg:text-[44px] lg:leading-[57px] leading-tight sm:text-[40px] text-3xl font-semibold text-gray-900">
            {hireDedicatedDevelopers.title}
          </h2>
          <p className="mt-5 text-lg leading-[29px] text-gray-700">
            {hireDedicatedDevelopers.description}
          </p>
          <div className="lg:mt-[60px] sm:mt-10 mt-7">
            <div className="grid lg:grid-cols-3 md:grid-cols-2 xl:gap-10 gap-8">
              {hireDedicatedDevelopers.pricing.map((pricing, index) => (
                <PricingCard
                  key={index}
                  title={pricing.title}
                  price={pricing.price}
                  priceUnit={pricing.priceUnit}
                  description={pricing.details}
                  isPopular={pricing.isPopular}
                />
              ))}
            </div>
            <div className="flex justify-center lg:mt-[60px] mt-10">
              <button
                onClick={() => setShowFreeQuotesModal(true)}
                type="button"
                className="px-10 pt-[9px] pb-[9px] my-auto sm:text-lg text-base font-medium text-center text-white bg-primary rounded-md !leading-[1.77] w-full max-w-[300px]"
              >
                Let’s Connect
              </button>
            </div>
          </div>
        </div>
      </section>
      <Portfolio />
      <CallToAction
        text={footerText}
        buttonText="Contact Us"
        isButton
        onButtonClick={() => setShowFreeQuotesModal(true)}
      />
      {showFreeQuotesModal && (
        <FreeQuotesModal
          dropdownName={dropdownName}
          onClose={() => setShowFreeQuotesModal(false)}
        />
      )}
    </Layout>
  );
};

export default HireDeveloperDetails;
